import React from 'react';
import css from './MobileMenuButton.module.scss';

interface MobileMenuButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

export function MobileMenuButton({ icon, label, onClick }: MobileMenuButtonProps) {
  return (
    <button className={css.menuItem} onClick={onClick}>
      <span className={css.iconCircle}>{icon}</span>
      <span>{label}</span>
    </button>
  );
}
